import { PictureUploader } from "@/components/PictureUploader";
import { UniversalRoutes } from "@/routers/routes";

export const PortraitUpload: React.FC = () => (
  <PictureUploader
    title="Upload Your Portrait"
    endpoint="/owner/profile/portrait"
    returnToRoute={UniversalRoutes.PROFILE.HOME}
  />
);

export const DogPortraitUpload: React.FC = () => (
  <PictureUploader
    title="Upload Your Dog Portrait"
    endpoint="/owner/dog/portrait"
    returnToRoute={UniversalRoutes.PROFILE.HOME}
  />
);
